import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Features from "@/components/sections/Features";
import Industries from "@/components/sections/Industries";
import Process from "@/components/sections/Process";
import TechStack from "@/components/sections/TechStack";
import CTA from "@/components/sections/CTA";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-white text-neutral-950">
      <Navbar />
      <Hero />
      <Marquee />
      <Features />
      <Industries />
      <Process />
      <TechStack />
      <CTA />
      <Footer />
    </main>
  );
}
